import React from 'react'
import Icon from 'srcReact/components/icons/Icon'
import LinkButton from 'srcReact/components/common2/LinkButton'

import { useTranslation } from 'react-i18next'

import styles from './styles.module.scss'
import allDatas from './datas'

const TableCell = ({ datas, position }) => {
  const colorFromPosition = () => {
    switch (position) {
      case 1:
        return 'black'
      case 2:
        return 'green'
      case 3:
        return 'purple'
      case 4:
        return 'yellow'
      default:
        ''
    }
  }
  const showValue = (val) => {
    switch (val) {
      case true:
        return <Icon name='checked' size='large' styleModifier={styles[colorFromPosition()]} />
      case false:
        return <Icon name='close' size='medium' styleModifier={styles.close} />

      default:
        return val
    }
  }
  if (datas.type === 'headerLeft' || datas.type === 'header') {
    return <th className={`${styles[datas.type]} ${styles[colorFromPosition()]}`}>{showValue(datas.value)}</th>
  }
  return (
    <td className={`${styles[datas.type]} ${styles[colorFromPosition()]}`}>
      {showValue(datas.value)}
      <br />
      <span className={styles.note}>{datas.note}</span>
    </td>
  )
}

const TableRow = ({ cells }) => {
  const cellsComps = cells.map((e, i) => <TableCell key={i} datas={e} position={i} />)
  return <tr>{cellsComps}</tr>
}

const PricingDetailsList = ({ nonProfit, countryCode }) => {
  const { t } = useTranslation()
  const rows = allDatas(t, countryCode).map((e, i) => <TableRow key={i} cells={e} />)
  return (
    <div className={styles.container}>
      <table className={styles.table}>{rows}</table>
      <div className={styles.containerBottom}>
        <div
          className={styles.boldText}
          dangerouslySetInnerHTML={{ __html: t('billing.pricing.bottomBlock.days30freeTrial') }}></div>
        {!nonProfit && (
          <div
            className={styles.subtitle}
            dangerouslySetInnerHTML={{ __html: t('billing.pricing.bottomBlock.ifAcademic') }}></div>
        )}
        <div className={styles.linkContainer}>
          <LinkButton
            href={`${config.webUrl}/0/signup`}
            size='large'
            text={t('global.get_started')}
            customStyle={styles.linkButton}
          />
        </div>
        <div className={styles.noteBottom}>{t('billing.pricing.bottomBlock.limits')} </div>
      </div>
    </div>
  )
}

export default PricingDetailsList
